var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","items":_vm.severities,"loading":_vm.loadingImages,"chips":"","label":"Filter Images By Severities","multiple":"","clearable":"","single-line":""},on:{"input":_vm.filterBySeverity},model:{value:(_vm.selectedSeverities),callback:function ($$v) {_vm.selectedSeverities=$$v},expression:"selectedSeverities"}})
}
var staticRenderFns = []

export { render, staticRenderFns }